import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import RaceResultPortal from './components/RaceResultPortal.js';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
Amplify.configure(awsconfig);

ReactDOM.createRoot(document.getElementById('root')).render(
  <>
    <App />
    <RaceResultPortal />
  </>
);

/** 
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send results to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
*/